import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-pdf-reader',
  templateUrl: './pdf-reader.component.html',
  styleUrls: ['./pdf-reader.component.scss'],
})
export class PdfReaderComponent  implements OnInit {
  // @Input() pdfSrc: string = '';
  @Input() pdfSrc: any;
  fileUploadInputs = ['pdf'];

  @Input() blocIndex: number = 0;
  @Output() inputChange = new EventEmitter<{
    pdfSrc: string;
  }>();

  constructor() { }

  ngOnInit() {
  }


  onInputChange(event: any) {
    this.pdfSrc = event.files[0];
    this.inputChange.emit({
      pdfSrc: this.pdfSrc,
    });
  }
}
